import script from "./ChatList.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatList.vue?vue&type=script&setup=true&lang=js"

import "./ChatList.vue?vue&type=style&index=0&id=160fd845&lang=less&scoped=true"

import exportComponent from "C:\\webproject\\ECNU_AI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-160fd845"]])

export default __exports__